module.exports = __webpack_public_path__ + "img/img4.292e282c.jpg";